import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import PeriodPicker from 'pages/parts/PeriodPicker'

import { httpOk, GET, FILE_D } from 'helpers/api'
import { formatMoney, returnSign, findKeyFromArrayByValue, formatDate } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip"
import { businessNow, businessDayStartOf, businessDayEndOf } from 'helpers/businessDay'

function Index() {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const orderTypes = [
		{ "id": 1, "name": t('hall') },
		{ "id": 2, "name": t('takeaway') },
		{ "id": 3, "name": t('delivery') },
	]

	const [poses, setPoses] = useState([])
	const [menu, setMenu] = useState([])
	const [waiters, setWaiters] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [orderSubTypes, setOrderSubTypes] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState(() => {
		// Сегодня — операционный день точки: при начале дня 03:00 это 03:00 … 02:59 следующего дня
		const n = businessNow()
		const startOfDay = businessDayStartOf(n)
		const endOfDay = businessDayEndOf(n)
		return {
			start_date: formatDate(startOfDay, 'yyyy-MM-dd HH:mm:ss'),
			end_date: formatDate(endOfDay, 'yyyy-MM-dd HH:mm:ss'),
			pos_id: reduxAccount.pos_id,
			search: '',
		}
	})
	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState([])
	const [modalDetail, setModalDetail] = useState(false)

	async function searchWithFilter(exportToExcel = false, nextFilterData = null) {
		var filterUrl = "/report-menu"
		var urlParams = ""
		checkFilter()
		const currentFilterData = nextFilterData || filterData

		if (currentFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + currentFilterData.pos_id
		if (currentFilterData.order_type_id)
			urlParams += returnSign(urlParams) + 'order_type_id=' + currentFilterData.order_type_id
		if (currentFilterData.order_type_sub_id)
			urlParams += returnSign(urlParams) + 'order_type_sub_id=' + currentFilterData.order_type_sub_id
		if (currentFilterData.payment_type_ids && currentFilterData.payment_type_ids.length > 0) {
			const ids = currentFilterData.payment_type_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'payment_type_ids=' + ids;
		}
		if (currentFilterData.menu_ids && currentFilterData.menu_ids.length > 0) {
			const ids = currentFilterData.menu_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'menu_ids=' + ids;
		}
		if (currentFilterData.waiter_ids && currentFilterData.waiter_ids.length > 0) {
			const ids = currentFilterData.waiter_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'waiter_ids=' + ids;
		}
		if (currentFilterData.shift_id)
			urlParams += returnSign(urlParams) + 'shift_id=' + currentFilterData.shift_id
		if (currentFilterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + currentFilterData.start_date
		if (currentFilterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + currentFilterData.end_date
		if (currentFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + currentFilterData.search

		if (`/report-menu${urlParams}` !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams
		if (exportToExcel) {
			// Файл собирает бэк (EReportMenu): разделы, итоги, рамки и разметка под печать на A4 —
			// SheetJS в браузере оформление не пишет, а без него распечатка сливается в кашу
			const response = await FILE_D(filterUrl + returnSign(filterUrl) + 'excel=true', { loader: true })
			if (httpOk(response)) {
				const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
				const fileUrl = URL.createObjectURL(file)
				const link = document.createElement('a')
				link.href = fileUrl
				link.setAttribute('download', `${t('menu')}.xlsx`)
				document.body.appendChild(link)
				link.click()
				link.remove()
				URL.revokeObjectURL(fileUrl)
			}
		}

		if (!exportToExcel) {
			const response = await GET(filterUrl, {}, { loader: true })
			if (httpOk(response)) setData(response.data)
		}

		setDropdownIsOpen(false)
	}

	function handleSearchChange(search) {
		const nextFilterData = { ...filterData, search, page: null }
		setFilterData(nextFilterData)
		searchWithFilter(false, nextFilterData)
	}

	async function toggleModal(item, type) {
		if (type === 'detail') {
			var filterDataCopy = { ...filterData }
			var filterUrl = `/report-menu-detail/${item.product_id}`
			var urlParams = ""

			if (filterDataCopy.pos_id)
				urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
			if (filterDataCopy.order_type_id)
				urlParams += returnSign(urlParams) + 'order_type_id=' + filterDataCopy.order_type_id
			if (filterDataCopy.order_type_sub_id)
				urlParams += returnSign(urlParams) + 'order_type_sub_id=' + filterDataCopy.order_type_sub_id
			if (filterDataCopy.shift_id)
				urlParams += returnSign(urlParams) + 'shift_id=' + filterDataCopy.shift_id
			if (filterDataCopy.start_date)
				urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
			if (filterDataCopy.end_date)
				urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
			if (filterDataCopy.search)
				urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search

			const response = await GET(filterUrl + urlParams, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setModalDetail(true)
			}
		}
	}

	function resetFilter() {
		const today = businessNow()
		const monthStart = businessDayStartOf(new Date(today.getFullYear(), today.getMonth(), 1))
		const todayEnd = businessDayEndOf(today)
		setFilterData({
			start_date: formatDate(monthStart, 'yyyy-MM-dd HH:mm:ss'),
			end_date: formatDate(todayEnd, 'yyyy-MM-dd HH:mm:ss'),
			pos_id: null,
			search: '',
		})
		setFilterDataExist(false)
		getData()
	}

	async function getData() {
		const today = businessNow()
		const monthStart = businessDayStartOf(new Date(today.getFullYear(), today.getMonth(), 1))
		const todayEnd = businessDayEndOf(today)
		const response = await GET(
			"/report-menu",
			{
				start_date: formatDate(monthStart, 'yyyy-MM-dd HH:mm:ss'),
				end_date: formatDate(todayEnd, 'yyyy-MM-dd HH:mm:ss'),
			},
			{ loader: true }
		)
		if (httpOk(response)) {
			setData(response.data)
		}
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getOrderSubTypes() {
		const response = await GET('/helper/order-type-subs')
		if (httpOk(response)) setOrderSubTypes(response.data)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function getMenu() {
		const response = await GET('/helper/menu', {}, { loader: true })
		if (httpOk(response)) setMenu(response.data)
	}

	async function getWaiters() {
		const response = await GET('/helper/waiters')
		if (httpOk(response)) setWaiters(response.data)
	}

	useEffect(() => {
		getPoses()
		getMenu()
		getWaiters()
		getPaymentTypes()
		getOrderSubTypes()
		searchWithFilter(false)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t('menu')} [{data?.data?.length}]
				</h4>
			</div>

			<div className="card mb-3">
				<div className="card-body">

					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={handleSearchChange}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('shift')} ID</label>
												<input type="text" className="form-control"
													onChange={(e) => setFilterData({ ...filterData, 'shift_id': e.target.value })} />
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('order_type')}</label>
												<Select
													options={orderTypes}
													value={orderTypes.find(option => option.id === filterData.order_type_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'order_type_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('delivery_type')}</label>
												<Select
													isClearable
													options={orderSubTypes}
													value={orderSubTypes.find(option => option.id === filterData.order_type_sub_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'order_type_sub_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('payment_types')}</label>
												<Select
													isMulti
													isClearable
													options={paymentTypes}
													value={filterData.payment_type_ids}
													onChange={(options) => setFilterData({ ...filterData, 'payment_type_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-12">
												<label>{t('menu')}</label>
												<Select
													isMulti
													isClearable
													options={menu}
													value={filterData.menu_ids}
													onChange={(options) => setFilterData({ ...filterData, 'menu_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-12">
												<label>{t('waiters')}</label>
												<Select
													isMulti
													isClearable
													options={waiters}
													value={filterData.waiter_ids}
													onChange={(options) => setFilterData({ ...filterData, 'waiter_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="form-group">
											<label>{t('period')}</label>
											{/* Один выбор периода вместо «Дата» и двух календарей */}
											<PeriodPicker
												startDate={filterData.start_date}
												endDate={filterData.end_date}
												onChange={(period) => setFilterData({ ...filterData, ...period })}
											/>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<CustomTooltip text={t('EXCEL')}>
									<button className="btn btn-outline-primary btn-wide-2"
										onClick={() => searchWithFilter(true)}>
										<i className="uil uil-file-download-alt"></i>
									</button>
								</CustomTooltip>
							</div>
						</div>
						<div className="vertical-center">
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('sales')}:</b> {formatMoney(data.total_sales)}
							</h6>
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('allowances')}:</b> {formatMoney(data.total_allowance)}
							</h6>
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('amount')}:</b> {formatMoney(data.total_amount)}
							</h6>
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('gross_income')}:</b> {formatMoney(data.total_income)}
							</h6>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.order_type_id &&
									<span className="me-2">
										<b>{t('order_type')}: </b>
										{findKeyFromArrayByValue(orderTypes, 'id', filterData.order_type_id, 'name')}
									</span>
								}
								{filterData.order_type_sub_id &&
									<span className="me-2">
										<b>{t('delivery_type')}: </b>
										{findKeyFromArrayByValue(orderSubTypes, 'id', filterData.order_type_sub_id, 'name')}
									</span>
								}
								{filterData.shift_id &&
									<span className="me-2">
										<b>{t('shift')} ID: </b> {filterData.shift_id}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}
				</div>
			</div>

			{/* Каждый раздел — своей карточкой (как было до сводной ленты): клиентам так привычнее.
			    Единая лента с итогами по родителям осталась в Excel, его собирает бэк. */}
			{data?.data?.map((item, index) => (
				<div className="card mb-3" key={index}>
					<div className="card-body">
						<div className="table-responsive" style={{ 'minHeight': 0 }}>
							<table className="table table-bordered table-hover mb-0">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '100%' }}>
											{item.parents?.length > 0 &&
												<span className="text-muted">{item.parents.map(parent => parent.name).join(' / ')} / </span>
											}
											{item.menu_name || '—'}
										</th>
										<th className="td-ellipsis" style={{ 'minWidth': '110px' }} title={t('unit')}>
											{t('unit')}
										</th>
										<th className="td-ellipsis text-end" style={{ 'minWidth': '110px' }} title={t('quantity')}>
											{t('quantity')}
										</th>
										<th className="td-ellipsis text-end" style={{ 'minWidth': '120px' }} title={t('sale_price')}>
											{t('sale_price')}
										</th>
										<th className="td-ellipsis text-end" style={{ 'minWidth': '120px' }} title={t('sales_amount')}>
											{t('sales_amount')}
										</th>
										<th className="td-ellipsis text-end" style={{ 'minWidth': '120px' }} title={t('income')}>
											{t('income')}
										</th>
										<th className="text-end" style={{ 'minWidth': '45px' }}>%</th>
									</tr>
								</thead>
								<tbody>
									{item.products.map((product, index2) => (
										<tr key={index2}
											className={(
												selectedItem &&
												selectedItem.product_id === product.product_id
											) ? 'table-tr-active' : ''}
											onClick={() => toggleModal(product, 'detail')}>
											<td className="text-center">{index2 + 1}</td>
											<td>{product.name}</td>
											<td className="text-nowrap">{product.unit_name}</td>
											<td className="text-end text-nowrap">{formatMoney(product.total_quantity, 2)}</td>
											<td className="text-end text-nowrap">{formatMoney(product.total_sales / product.total_quantity)}</td>
											<td className="text-end text-nowrap">{formatMoney(product.total_sales)}</td>
											<td className="text-end text-nowrap">{formatMoney(product.total_income)}</td>
											<td className="text-end text-nowrap">{formatMoney(product.sale_percent, 2)}</td>
										</tr>
									))}
									<tr>
										<td></td>
										<td colSpan="2"><b>{t('total')}</b></td>
										<td className="text-end text-nowrap"><b>{formatMoney(item.total_quantity, 2)}</b></td>
										<td></td>
										<td className="text-end text-nowrap"><b>{formatMoney(item.total_sales)}</b></td>
										<td className="text-end text-nowrap"><b>{formatMoney(item.total_income)}</b></td>
										<td className="text-end"><b>100</b></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			))}

			<Modal show={modalDetail} animation={false} size="lg" centered onHide={() => setModalDetail(false)}>
				<Modal.Body>
					<h3 className="mb-3">{selectedItem.first_name}</h3>
					<div className="table-responsive inventory-modal-height">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '25%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('sale_price')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('sales_amount')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('income')}</th>
								</tr>
							</thead>
							<tbody>
								{selectedItem?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td className="text-end">{formatMoney(item.total_quantity)}</td>
										<td className="text-end">{formatMoney(item.price)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.total_sales)}</td>
										<td className="text-end">{formatMoney(item.total_income)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index